import { computed, ref, watch, onMounted } from 'vue'

/**
 * 全站与 `header.vue` changeLanguage / i18n 路由一致的语言列表。
 * 与 `docs/color-shell-spec.md` 中交互色（violet / brand）配合，由 `LocaleSwitcherMenu` 展示。
 */
export const LOCALE_OPTIONS = [
  { code: 'en', label: 'English', abbr: 'EN' },
  { code: 'ru', label: 'Русский', abbr: 'RU' },
  { code: 'id', label: 'Indonesia', abbr: 'ID' },
  { code: 'zh', label: '简体中文', abbr: '简' },
  { code: 'cn', label: '繁體中文', abbr: '繁' },
  { code: 'ja', label: '日本語', abbr: 'JA' },
  { code: 'de', label: 'Deutsch', abbr: 'DE' },
  { code: 'fr', label: 'Français', abbr: 'FR' },
  { code: 'pt', label: 'Português', abbr: 'PT' },
  { code: 'es', label: 'Español', abbr: 'ES' },
  { code: 'it', label: 'Italiano', abbr: 'IT' },
  { code: 'kr', label: '한국어', abbr: 'KO' },
  { code: 'ar', label: 'العربية', abbr: 'AR' },
  { code: 'tr', label: 'Türkçe', abbr: 'TR' },
  { code: 'nl', label: 'Nederlands', abbr: 'NL' },
]

function labelForCode(code) {
  return LOCALE_OPTIONS.find((o) => o.code === code)?.label ?? 'English'
}

function abbrForCode(code) {
  return LOCALE_OPTIONS.find((o) => o.code === code)?.abbr ?? String(code).toUpperCase().slice(0, 2)
}

/**
 * 切换语言并同步展示名、sessionStorage（与历史 `header.vue` 行为一致）。
 */
export function useLocaleSwitcher() {
  const { locale, setLocale } = useI18n()
  const displayLabel = ref('English')

  /** 顶栏 icon 模式：展示当前语言简称（与下拉项一一对应） */
  const displayLocaleAbbr = computed(() => abbrForCode(locale.value))

  function hydrateFromLocale() {
    displayLabel.value = labelForCode(locale.value)
  }

  function applyLocale(code) {
    setLocale(code)
    displayLabel.value = labelForCode(code)
    if (import.meta.client) {
      sessionStorage.setItem('language', displayLabel.value)
    }
  }

  onMounted(hydrateFromLocale)
  watch(locale, hydrateFromLocale)

  return {
    LOCALE_OPTIONS,
    displayLabel,
    displayLocaleAbbr,
    applyLocale,
    hydrateFromLocale,
    labelForCode,
    abbrForCode,
  }
}
